import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  selectBookingPageSettings,
  selectBookingPageSettingsStatus,
} from "../../features/trial-requests/trial-requests-slice";
import { setHeroPreset } from "../../features/trial-requests/slice-extensions/trial-requests-slice-extension";
import { HERO_PRESETS } from "../../features/trial-requests/utils/heroPresets";

/**
 * Gallery of shared hero backgrounds — one click applies a preset, no photo
 * needed. Renders nothing while the gallery manifest is empty.
 */
const HeroPresetPicker = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const settings = useAppSelector(selectBookingPageSettings);
  const status = useAppSelector(selectBookingPageSettingsStatus);

  if (HERO_PRESETS.length === 0 || !settings) {
    return null;
  }

  return (
    <div className="mt-3">
      <p className="text-xs text-grey-40 dark:text-grey-80">
        {t("website.presetHint", "…or pick a ready-made background:")}
      </p>
      <div className="mt-2 grid grid-cols-3 gap-2 sm:grid-cols-4">
        {HERO_PRESETS.map((presetImage) => {
          const selected = settings.heroImageUrl === presetImage.url;
          return (
            <button
              key={presetImage.url}
              type="button"
              disabled={status === "loading"}
              onClick={() => dispatch(setHeroPreset(presetImage.url))}
              className={
                selected
                  ? "relative overflow-hidden rounded-lg ring-2 ring-primary-40 dark:ring-primary-90"
                  : "relative overflow-hidden rounded-lg opacity-90 hover:opacity-100"
              }
              aria-label={presetImage.topic}
              title={presetImage.topic}
            >
              <img
                src={presetImage.url}
                alt={presetImage.topic}
                loading="lazy"
                className="h-14 w-full object-cover"
              />
              {selected && (
                <span className="absolute right-1 top-1 rounded-full bg-primary-40 p-0.5 text-white dark:bg-primary-90 dark:text-primary-10">
                  <Check size={12} />
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default HeroPresetPicker;
